import React, { useState, useRef, useEffect } from "react";
import AllTimeline from "./allTimeline";
import { GetNews } from "../../apis/api/NewsApi";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Lodderr from "../../components/Lodder/Lodder";
import { formatDMY } from "../../utils/date";
import { motion } from "framer-motion";
import "./Feeds.css";
const Timeline = () => {

  const dispatch= useDispatch();
  const navigate=useNavigate()
  useEffect(()=>{
   dispatch(GetNews());
  },[])
 
   const {news} = useSelector((state) => state.NewsSlice);
 const {loading} = useSelector((state) => state.NewsSlice);

 
   const handleRedirect = (news) => {
    navigate("/newsArticle", { state: { newsData: news } });
  };

  return (
    <>
      {loading && <Lodderr/>}

      <motion.div
        className="tf-wrap"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 0.68, 0, 1.2] }}
      >
        <div className="tf-grid">
          <div className="tf-main">
            <AllTimeline/>
          </div>

          <aside className="tf-side">
            <div className="tf-side-head">
              <div className="tf-side-title">
                <i className="bx bx-news"></i>
                <h5>Latest News</h5>
              </div>
              <span className="tf-pill">{(news || []).length} items</span>
            </div>

            <div className="tf-news">
              {(news || []).slice(0, 6).map((n, idx) => (
                <button
                  key={n.id || idx}
                  className="tf-news-card"
                  onClick={() => handleRedirect(n)}
                  type="button"
                >
                  <div className="tf-news-img">
                    <img
                      src={n.image ? n.image?.replace("/thumb", "") : "assets/images/dummy-news-img.jpeg"}
                      className="card-img-top"
                      alt={n.title}
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "assets/images/dummy-news-img.jpeg";
                      }}
                    />
                  </div>
                  <div className="tf-news-body">
                    <div className="tf-news-title">{n.title}</div>
                    <div className="tf-news-date">
                      <i className="bx bx-calendar"></i> {formatDMY(n.date || n.created_at)}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </aside>
        </div>
      </motion.div>
    </>
  );
};

export default Timeline;
